<template>
    <div>
        <v-container fluid>
            <v-row>
                <v-col>
                    <v-breadcrumbs :items="breadcrumbs">
                        <template v-slot:divider>
                            <v-icon>chevron_right</v-icon>
                        </template>
                    </v-breadcrumbs>
                </v-col>
            </v-row>
            <v-row >
                <v-col>
                    <v-tabs v-model="activeTab"
                            background-color="primary"
                            dark>
                        <v-tab :to="`/services/${serviceId}`">
                            Overview
                        </v-tab>
                        <v-tab :to="`/services/${serviceId}/edit`">
                            Edit
                        </v-tab>
                    </v-tabs>
                </v-col>
            </v-row>
            <v-row >
                <v-col>
                    <v-card>
                        <v-card-text class="text--primary">
                            <router-view :service="service"></router-view>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
    import {mapGetters, mapState} from 'vuex'

    export default {
        name: "Service",
        props: {
            serviceId: String
        },
        data() {
            return {
                activeTab: null
            }
        },
        computed: {
            ...mapState({}),
            ...mapGetters({
                serviceById: 'services/serviceById'
            }),
            breadcrumbs() {
                let currentRouteName = this.$router.currentRoute.name
                const service = this.serviceById(this.serviceId)
                return [
                    {
                        text: 'Services',
                        disabled: false,
                        href: '#/services'
                    },
                    {
                        text: service.title,
                        disabled: true,
                    }
                ]
            },
            service () {
                return this.serviceById(this.serviceId) || null
            }
        }
    }
</script>

<style scoped>

</style>